import { APP_VERSION, BUILD_DATE } from '../buildInfo';

export default function AppFooter() {
  return (
    <footer
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 11,
        color: '#888',
        padding: '6px 0',
        pointerEvents: 'none',
      }}
    >
      v{APP_VERSION} · Published: {BUILD_DATE}
    </footer>
  );
}
